export const DEFAULT_ICON_MAP: { [key: string]: string } = {
  email: 'mdi-email',
  phone: 'mdi-phone',
  username: 'mdi-account',
  first_name: 'mdi-account',
  last_name: 'mdi-account',
};
